export const v1ConfigJSONToV2ConfigJSON = (configJSON: string) => {
  const replaceAll = (str: string, search: string, replace: string) => str.split(search).join(replace);

  // States
  configJSON = replaceAll(configJSON, 'does-app-ongoing-task-exist', 'is-any-task-in-progress');
  configJSON = replaceAll(configJSON, 'does-app-ongoing-install-task-exist', 'is-install-task-in-progress');
  configJSON = replaceAll(configJSON, 'does-app-ongoing-update-task-exist', 'is-update-task-in-progress');
  configJSON = replaceAll(configJSON, 'does-app-ongoing-repair-task-exist', 'is-repair-task-in-progress');
  configJSON = replaceAll(configJSON, 'does-app-ongoing-move-task-exist', 'is-move-task-in-progress');
  configJSON = replaceAll(configJSON, 'does-app-ongoing-uninstall-task-exist', 'is-uninstall-task-in-progress');
  configJSON = replaceAll(configJSON, 'does-app-last-task-failed', 'has-any-task-failed');

  // Commands
  configJSON = replaceAll(configJSON, 'minimize-window-command', 'minimizeWindowCommand');
  configJSON = replaceAll(configJSON, 'hide-window-command', 'hideWindowCommand');
  configJSON = replaceAll(configJSON, 'maximize-restore-window-command', 'maximizeOrRestoreWindowCommand');
  configJSON = replaceAll(configJSON, 'start-app-command', 'startAppCommand');
  configJSON = replaceAll(configJSON, 'start-app-install-task-command', 'startAppInstallTaskCommand');
  configJSON = replaceAll(configJSON, 'start-app-uninstall-task-command', 'startAppUninstallTaskCommand');
  configJSON = replaceAll(configJSON, 'start-app-update-task-command', 'startAppUpdateTaskCommand');
  configJSON = replaceAll(configJSON, 'start-app-repair-task-command', 'startAppRepairTaskCommand');
  // configJSON = replaceAll(
  //   configJSON,
  //   'cancel-app-ongoing-task-command',
  //   ''
  // );
  // configJSON = replaceAll(
  //   configJSON,
  //   'restart-last-app-task-command',
  //   ''
  // );
  configJSON = replaceAll(configJSON, 'open-external-link-command', 'openExternalLinkCommand');

  // Variables
  configJSON = replaceAll(configJSON, 'app-name', 'appName');
  configJSON = replaceAll(configJSON, 'app-description', 'appDescription');
  configJSON = replaceAll(configJSON, 'app-version-label', 'appVersionLabel');
  configJSON = replaceAll(configJSON, 'app-task-operation-name', 'appTaskOperationName');
  configJSON = replaceAll(configJSON, 'app-task-package-size', 'appTaskPackageSize');
  configJSON = replaceAll(configJSON, 'app-task-downloaded-size', 'appTaskDownloadedSize');
  configJSON = replaceAll(configJSON, 'app-task-download-speed', 'appTaskDownloadSpeed');
  configJSON = replaceAll(configJSON, 'app-task-percentage', 'appTaskPercentage');
  configJSON = replaceAll(configJSON, 'app-install-path', 'appInstallPath');
  configJSON = replaceAll(configJSON, 'app-install-package-size', 'appInstallPackageSize');
  configJSON = replaceAll(configJSON, 'app-update-package-size', 'appUpdatePackageSize');

  // Elements
  configJSON = replaceAll(configJSON, 'appTaskProgressBar', 'appTaskProgressBarFill');

  return configJSON;
};
